import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';

export default {
  setDashboards(state, { dashboards, selectedAccountIds, search }) {
    if (!Array.isArray(dashboards)) {
      throw new Error('Dashboards must be an array');
    }

    if (!Array.isArray(selectedAccountIds)) {
      throw new Error('selectedAcountIds must be an array');
    }

    if (!isEqual(selectedAccountIds, state.selectedAccountIds) || state.search !== search) {
      state.dashboards = dashboards;
      return;
    }

    const mergedDashbaords = state.dashboards.map((dashboard) => {
      const updatedDashboard = dashboards.find((d) => d.id === dashboard.id);

      return updatedDashboard || dashboard;
    });

    dashboards.forEach((newDashboard) => {
      const oldDashboard = state.dashboards.find((d) => d.id === newDashboard.id);

      if (oldDashboard) {
        return;
      }

      return mergedDashbaords.push(newDashboard);
    });

    state.dashboards = mergedDashbaords;
  },
  setDashboard(state, updatedDashboard) {
    const newDashboards = [];
    let wasAdded = false;
    state.dashboards.forEach((oldDashboard) => {
      if (oldDashboard.id === updatedDashboard.id) {
        newDashboards.push(updatedDashboard);
        wasAdded = true;
      } else {
        newDashboards.push(oldDashboard);
      }
    });

    if (!wasAdded) {
      newDashboards.push(updatedDashboard);
    }

    state.dashboards = newDashboards;
  },
  addDashboard(state, dashboard) {
    state.dashboards = [...state.dashboards, dashboard];
  },
  removeDashboard(state, id) {
    state.dashboards = state.dashboards.filter((dashboard) => dashboard.id !== id);
  },
  startFetching(state) {
    state.status = 'loading';
  },
  finishFetching(state) {
    state.status = 'loaded';
  },
  failedFetching(state, error) {
    state.status = 'failed';
    state.error = error;
  },
  addWidget(state, { dashboardId, widget }) {
    const dashboard = state.dashboards.find((d) => d.id === dashboardId);

    if (!dashboard) {
      throw new Error('Dashboard not found');
    }

    dashboard.value.widgets.push(widget);
  },
  updateWidgetOrder(state, { dashboardId, widgetOrder }) {
    const dashboard = state.dashboards.find((d) => d.id === dashboardId);

    if (!dashboard) {
      throw new Error('Dashboard not found');
    }

    dashboard.value.widgets = widgetOrder.map(({ widgetId, layoutOrderIdx }) => {
      const widget = dashboard.value.widgets.find((w) => w.id === widgetId);

      if (!widget) {
        throw new Error('Widget not found');
      }

      widget.layoutOrderIdx = layoutOrderIdx;

      return widget;
    });
  },
  updateWidgetProperty(state, { dashboardId, property, widgetId, value }) {
    const dashboard = state.dashboards.find((d) => d.id === dashboardId);

    if (!dashboard) {
      throw new Error('Dashboard not found');
    }

    const widget = dashboard.value.widgets.find((w) => w.id === widgetId);

    if (!widget) {
      throw new Error('Widget not found');
    }

    widget[property] = value;
  },
  removeWidget(state, { dashboardId, widgetId }) {
    const dashboard = state.dashboards.find((d) => d.id === dashboardId);

    if (!dashboard) {
      throw new Error('Dashboard not found');
    }

    const widget = dashboard.value.widgets.find((w) => w.id === widgetId);

    if (!widget) {
      throw new Error('Widget not found');
    }

    dashboard.value.widgets = dashboard.value.widgets.filter((w) => w.id !== widgetId);
  },
  updateDashboardProperty(state, { dashboardId, property, value }) {
    const clone = cloneDeep(state.dashboards);
    const dashboard = clone.find((d) => d.id === dashboardId);

    if (!dashboard) {
      throw new Error('Dashboard not found');
    }

    set(dashboard, property, value);

    state.dashboards = clone;
  },
};
